import { createState } from 'shared'

const emailStateContainer = createState('')
export const emailState = emailStateContainer.state

const emailFieldErrorStateContainer = createState('')
export const emailFieldErrorState = emailFieldErrorStateContainer.state

const isValidEmail = (email: string) => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return emailRegex.test(email)
}

export const setEmailFieldError = (errorMessage: string) => {
	emailFieldErrorStateContainer.updateState(() => errorMessage)
}

export const setEmail = (email: string) => {
	emailStateContainer.updateState(() => email)

	setEmailFieldError(
		!isValidEmail(email) ? 'Please enter a valid email address' : ''
	)
}
